module.exports = __webpack_public_path__ + "img/phone-mb.7dabe076.webp";